import { IsNotEmpty, IsUUID, IsString } from 'class-validator';

import { NOT_EMPTY_OPTIONS } from '../../constants';

export class DeclineSignDto {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  eventId: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  nodeId: string;

  @IsString({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  comment: string;
}
